module.exports = __webpack_public_path__ + "static/media/img-upload.e390c698.svg";